import Button from "rsuite/Button";
import Modal from "rsuite/Modal";
import { useEffect, useMemo, useState } from "react";
import { useRef } from "react";
import { Stripe } from "@stripe/stripe-js";
import { Utility } from "../config";
import { useAppSelector } from "../core/redux/ReduxStore";
import { AppUserRoles } from "../config/constants";
import { useHistory } from "react-router-dom";
import { ApiCompany } from "../core/apis";
import { showSuccessToast } from "./toast.component";

export const SubscribeModal = () => {
  const { subscribed } = useAppSelector((state) => state.company);
  const { userRole } = useAppSelector((state) => state.auth);
  const stripe = useRef<Stripe>();
  const routeHistory = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const open = useMemo(
    () => userRole === AppUserRoles.Admin && !subscribed,
    [subscribed, userRole]
  );

  useEffect(() => {
    stripe.current = Utility.getStripe();
  }, []);

  const handleRequestSubscription = async () => {
    setIsLoading(true);
    const requested = await ApiCompany.RequestSubscription();
    if (requested) {
      showSuccessToast("Requested successfully");
    }
    setIsLoading(false);
    routeHistory.goBack();
  };

  return (
    <Modal backdrop="static" keyboard={false} open={open}>
      <Modal.Body>
        <p>
          You are not subscribed to any plan currently. Please request super
          admin to add a subscription.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="subtle"
          disabled={isLoading}
          onClick={() => routeHistory.goBack()}
        >
          Go back
        </Button>
        <Button
          appearance="primary"
          loading={isLoading}
          onClick={handleRequestSubscription}
        >
          Request Subscription
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
